import { useState } from 'react';
import * as useAPI from 'hooks/useAPI';
import * as api from 'config/api';
import { TransactionsCategoryType } from 'config/consts';

export type Transaction = {
  account: string;
  brokerName?: string;
  rawCategoryType: string; // 親カテゴリー・子カテゴリーを失わないように念の為残しておく
  category: typeof TransactionsCategoryType[keyof typeof TransactionsCategoryType];
  categoryText: string;
  description: string;
  amount: number;
  amountUSD: number | null;
  datetime: Date;
};
type Transactions = {
  items: Transaction[];
};
type State = useAPI.State<'transactions', Transactions>;
type UseGetTransactions = {
  transactions: State;
  getTransactions: (arg: { accountId?: string; reportType?: number }) => void;
};
export const categoryStrToTransactionCategoryType = (
  str: string
):
  | typeof TransactionsCategoryType[keyof typeof TransactionsCategoryType]
  | null => {
  return (
    Object.values(TransactionsCategoryType).find(value =>
      str.startsWith(value)
    ) ?? null
  );
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const testConvertFrom = <T>(_: T): Transactions => {
  const testConvertFrom_ = <T>(_: T): Transaction => {
    const category = Object.values(TransactionsCategoryType)[
      Math.floor(Math.random() * Object.values(TransactionsCategoryType).length)
    ] as typeof TransactionsCategoryType[keyof typeof TransactionsCategoryType];
    return {
      account: 'account',
      brokerName: 'brokerName',
      rawCategoryType: Object.values(TransactionsCategoryType)[
        Math.floor(
          Math.random() * Object.values(TransactionsCategoryType).length
        )
      ] as typeof TransactionsCategoryType[keyof typeof TransactionsCategoryType],
      category,
      categoryText: `${Math.floor(Math.random() * 40)}`,
      description:
        Object.entries(TransactionsCategoryType).find(item => {
          const [, value] = item;
          return value === category;
        })?.[0] ?? '見つからなかった',
      amount: 1000000 + Math.random() * -2000000,
      amountUSD:
        Math.random() > 0.5 ? 1000000 + Math.random() * -2942525 : null,
      datetime: new Date(
        new Date().getTime() - Math.random() * 1000 * 24 * 60 * 60 * 1000
      ),
    };
  };
  return {
    items: Array.from({ length: 700 })
      .map(_ => testConvertFrom_({}))
      .sort((a, b) => a.datetime.getTime() - b.datetime.getTime()),
  };
};
export const useGetTransactions = (): UseGetTransactions => {
  const convertFrom = (result: api.GetTransactionResult): Transactions => {
    return {
      items: result.Items.map(item => {
        return item.BrokerName !== undefined
          ? {
              account: item.Account,
              brokerName: item.BrokerName,
              amount: item.Amount,
              rawCategoryType: item.Category,
              category:
                categoryStrToTransactionCategoryType(
                  typeof item.Category === 'string' ? item.Category : ''
                ) ??
                (TransactionsCategoryType[
                  '未定'
                ] as typeof TransactionsCategoryType[keyof typeof TransactionsCategoryType]),
              categoryText: item.CategoryText,
              datetime: new Date(item.DateTime.replace(' ', 'T')),
              description: item.Description,
              amountUSD: item.AmountUSD,
            }
          : {
              account: item.Account,
              amount: item.Amount,
              rawCategoryType: item.Category,
              category:
                categoryStrToTransactionCategoryType(
                  typeof item.Category === 'string' ? item.Category : ''
                ) ??
                (TransactionsCategoryType[
                  '未定'
                ] as typeof TransactionsCategoryType[keyof typeof TransactionsCategoryType]),
              categoryText: item.CategoryText,
              datetime: new Date(item.DateTime.replace(' ', 'T')),
              description: item.Description,
              amountUSD: item.AmountUSD,
            };
      }),
    };
  };

  const [transactions, setTransactions] = useState<State>(useAPI.loading);
  const getTransactions = async (arg: {
    accountId?: string;
    reportType?: number;
  }): Promise<void> => {
    const result = await api.getTransactions(
      arg.accountId ?? undefined,
      arg.reportType ?? undefined
    );
    setTransactions(useAPI.loaded({ transactions: convertFrom(result) })); // こちらでtestConvertFromを利用すればよい
  };
  const ret: UseGetTransactions = {
    transactions,
    getTransactions,
  };
  return ret;
};
